<template>
    <div class="main">
        <h3>{{ $t('reservationSelectUnit.title')}}</h3>
        <p class="hint">{{ $t('reservationSelectUnit.alert')}}</p>
        <div class="box-shadow">
            <el-collapse v-model="initUnitType.id" accordion @change="handleChange">
                <el-radio-group v-model="selectedUnit" @change="handleChange">
                    <div
                        v-for="item in reservation_val.project.available_unit_types"
                        :key="item.unit_type_id"
                    >
                        <el-collapse-item
                            :name="item.unit_type_id"
                            :class="{'noPic' : !item.images}"
                        >
                            <template slot="title">
                                <el-radio :label="item.unit_type_id"></el-radio>
                                {{ item.label }}
                            </template>
                            <img v-if="!!item.images" :src="item.picture" alt="UNIT TYPE IMAGE">
                        </el-collapse-item>
                    </div>
                </el-radio-group>
            </el-collapse>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReservationSelectUnit",
    data() {
        return {
            initUnitType: {
                id: "",
                name: ""
            },

            selectedUnit: "",
            reservation_val: this.$root.reservation,
            project_val: this.$root.project,
            publishabel_val: this.$root.publishableKey
        };
    },
    mounted() {
        this.initUnitType = {
            id: this.reservation_val.project.available_unit_types[0]
                .unit_type_id,
            label: this.reservation_val.project.available_unit_types[0].label
        };
        
        this.selectedUnit = this.initUnitType.id;

        this.$emit("handleChange", this.initUnitType);
    },

    methods: {
        handleChange(val) {
            if(val && val != ""){
                this.selectedUnit = val;
            }else {
                return ;
            }
            
            this.reservation_val.project.available_unit_types.filter(it => {
                if (it.unit_type_id == this.selectedUnit) {
                    this.initUnitType.id = it.unit_type_id;
                    this.initUnitType.label = it.label;
                }
            });

            this.$emit("handleChange", this.initUnitType);
        }
    }
};
</script>

<style scoped>
@import "../assets/css/payment-common.css";

.box-shadow >>> .el-collapse-item {
    border-bottom: 1px solid #ebeef5;
}

.box-shadow >>> .el-radio-group > div:last-child .el-collapse-item__header,
.box-shadow >>> .el-radio-group > div:last-child .el-collapse-item {
    border-bottom: 0;
}
.box-shadow >>> .el-collapse-item.noPic .el-collapse-item__wrap {
    display: none;
}

.box-shadow >>> .el-collapse-item.noPic .el-collapse-item__header.is-active {
    border-bottom-color: #ebeef5;
}

.box-shadow >>> .el-collapse-item .el-collapse-item__content {
    padding: 28px 60px;
}

.box-shadow >>> .el-collapse-item .el-collapse-item__content img {
    width: 100%;
    max-height: 500px;
    object-fit: contain;
}

.box-shadow >>> .el-collapse-item.noPic .el-collapse-item__header .el-icon-arrow-right {
    display: none;
}

.box-shadow >>> .el-collapse-item .el-collapse-item__header .el-icon-arrow-right {
    margin-right: 30px;
}

.box-shadow >>> .el-collapse-item .el-radio {
    top: 28px;
    left: 23px;
}

@media (max-width: 768px) {
    .box-shadow >>> .el-collapse-item .el-collapse-item__content {
        padding-left: 13px;
        padding-right: 25px;
    }
}

@media (max-width: 414px) {
    .box-shadow >>> .el-collapse-item .el-collapse-item__content {
        padding: 0 27px 30px 13px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ReservationSelectUnit.vue